import MediaFile from 'Flow2/util/MediaFile';

export const getRoomMember = (json) => {
    const member = { members: [], pwd: "" };

	try {
		let obj = JSON.parse(json);
		if(obj && (typeof obj === 'object') && !Array.isArray(obj)) {
			member.pwd = obj.pwd;
			member.members = obj.members || obj.data;
		}
		console.log(member.data);
	} catch (err1) {
		console.log(err1);
	}
	
	return member;
}

class RoomZip {
    
    constructor(props) {
		this.props = props;
		this.state = {
			dlformats: props.room.dlformats ? props.room.dlformats.split(',') : [],
			medialang: props.room.medialang || ""
		}
    }
	
	createZip = () => {
		if(this.state.dlformats) {
			const clips = this.props.clips;
			let zip = [];
			
			clips.forEach((clip) => {
				if(clip.mediafiles.length) {
					zip = zip.concat(this.loopMediafiles(clip.mediafiles, clip.mediaType));
				}
			});

			return zip;
		}
		
		return [];
	}
	
	loopMediafiles = (mediafiles = [], type = "") => {
		let matchedFiles = {};
		for(let i = 0; i < mediafiles.length; i++) {
			let mediafile = mediafiles[i].data;
			
			switch(true) {
				case type.indexOf('video') !== -1:
					if(this.isVideo(mediafile)) {
						// only check the formats if the file is a video
						matchedFiles = this.checkMediaFile(matchedFiles, this.state.dlformats, mediafile);				
					}
					break;
				case type.indexOf('pictures') !== -1:
					// prevent to insert thumbnails - have no extention
					if(this.hasFileExtention(mediafile) && this.isImage(mediafile)) {
						let fileExt = MediaFile.getFileExtention(mediafile.filename);
						matchedFiles = this.setMediaFile(matchedFiles, fileExt, mediafile);
					}
					break;
				case type.indexOf('other') !== -1:
					// prevent to insert thumbnails - have no extention
					if(this.hasFileExtention(mediafile) && !this.isImage(mediafile)) {
						let fileExt = MediaFile.getFileExtention(mediafile.filename);
						matchedFiles = this.setMediaFile(matchedFiles, fileExt, mediafile);
					}
					break;
				default:
					break;
			}
		}

		
		const selection = this.checkLanguage(matchedFiles);
		const values = Object.values(selection);
		let ids = values.map(obj => {
			return obj[0].id;
		});
		
		ids = this.checkResize(mediafiles, ids);
		
		return [ ...ids ];
	}
	
	isDownloadRoom = (room) => {
		return room.roomtype === "Download";
	}
	
	hasDownloadFormats = (formats) => {
		return formats.length > 0;
	}
	
	isVideo = (mediafile) => {
		return mediafile && MediaFile.isVideo(mediafile);
	}
	
	isImage = (mediafile) => {
		return mediafile && MediaFile.isImage(mediafile);
	}
	
	hasFileExtention = (mediafile) => {
		return mediafile.filename && MediaFile.hasFileExtention(mediafile.filename);
	}
	
	isSource = (mediafile) => {
		return mediafile.sourcefile;
	} 
	
	isDerivate = (mediafile) => {
		return mediafile.tags && mediafile.tags.indexOf("mp4_") !== -1;
	}
	
	isFormat = (mediafile, format) => {
		return mediafile.tags && mediafile.tags.indexOf("mp4_" + format) !== -1;
	}
	
	isLanguage = (mediafile, lang) => {
		if(!mediafile.tags) { return false; }
		const tags = mediafile.tags.split(',');
		return tags.indexOf(lang) !== -1;
	}
	
	checkMediaFile = (match, formats, mediafile) => {
		formats.forEach(format => {
			if(format === "source") {
				if(!this.isDerivate(mediafile) && this.isSource(mediafile)) {
					match = this.setMediaFile(match, format, mediafile);
				}
			} else {
				if(this.isDerivate(mediafile) && this.isFormat(mediafile, format)) {
					match = this.setMediaFile(match, format, mediafile);
				}
			}
		});
		
		return match;
	}
	
	checkLanguage = (match) => {
		const langs = ["en", "de"];
		let selection = {};
		
		if(this.state.medialang) {
			langs.unshift(this.state.medialang);
		}
		
		const keys = Object.keys(match);
		for(let i = 0; i < keys.length; i++) {
			let files = match[keys[i]];
			
			for(let j = 0; j < langs.length; j++) {
				for(let k = 0; k < files.length; k++) {
					if(this.isLanguage(files[k], langs[j])) {
						selection = this.setMediaFile(selection, keys[i], files[k]);
						j = langs.length;
						k = files.length;
					}
				}
			}
			
			if(!selection[keys[i]] || !selection[keys[i]].length) {
				selection = this.setMediaFile(selection, keys[i], files[0]);
			}
		}
		
		return selection;
	}
	
	checkResize = (mediafiles, ids) => {
		const resized = []; // set resize ids of images and all other ids
		
		ids.forEach(id => {
			let mediafile = this.getMediafile(mediafiles, id);
			if(this.isImage(mediafile)) {
				if(this.state.dlformats.indexOf("source") !== -1) {
					resized.push(id);
				}
				if(this.state.dlformats.indexOf("1080p") !== -1) {
					resized.push(id + "@h");
				}
				if(this.state.dlformats.indexOf("720p") !== -1) {
					resized.push(id + "@m");
				}
				if(this.state.dlformats.indexOf("576p") !== -1) {
					resized.push(id + "@l");
				}
			} else {
				resized.push(id);
			}
		});
		
		return [ ...resized ];
	}
	
	getMediafile = (mediafiles, id) => {
		for(let i = 0; i < mediafiles.length; i++) {
			if(mediafiles[i].id == id) {
				return mediafiles[i];
			}
		}
		
		return null;
	}
	
	setMediaFile = (match, format, mediafile) => {
		if(!match[format]) {
			match[format] = [];
		}
		match[format].push(mediafile);
		
		return match;
	} 
}

export default RoomZip


